module.exports = __webpack_public_path__ + "img/waitlist.971cdffa.svg";